import { NavLink } from 'react-router-dom';
import { ChartAreaStacked, Gear, SquareListUl } from '@gravity-ui/icons';
import { Icon } from '@gravity-ui/uikit';

import { ADMIN, ANALYTICS, LIST } from './constants';

import styles from './styles.module.scss';
export const NavigationMobile = ({ role, isAdminMode, setIsAdminMode, isAdaptive }: any) => {
	const iconSize = isAdaptive ? 13 : 16;

	return (
		<>
			<nav className={`${styles.navigation} ${styles.navigation__mobile}`}>
				<div className={`${styles.navigation__pages} ${styles.navigation__pages__mobile}`}>
					<NavLink to="/" className={styles.navigation__button__mobile}>
						{({ isActive }) => (
							<button
								className={
									isActive
										? `${styles.navigation__button} ${styles.navigation__button__mobile} ${styles.active}`
										: `${styles.navigation__button} ${styles.navigation__button__mobile} `
								}
							>
								<Icon data={SquareListUl} size={iconSize} />
								{LIST}
							</button>
						)}
					</NavLink>

					<NavLink to="/charts" className={styles.navigation__button__mobile}>
						{({ isActive }) => (
							<button
								className={isActive
									? `${styles.navigation__button} ${styles.navigation__button__mobile} ${styles.active}`
									: `${styles.navigation__button} ${styles.navigation__button__mobile} `
								}
							>
								<Icon data={ChartAreaStacked} size={iconSize} />
								{ANALYTICS}
							</button>
						)}
					</NavLink>

					{role === 'ADMIN' ? (
						<NavLink
							to="admin"
							onClick={() => setIsAdminMode(true)}
							className={styles.navigation__button__mobile}
						>
							{({ isActive }) => (
								<button
									className={
										isActive
											? `${styles.navigation__button} ${styles.navigation__button__mobile} ${styles.active}`
											: `${styles.navigation__button} ${styles.navigation__button__mobile} `
									}
								>
									<Icon data={Gear} size={16} />
									{ADMIN}
								</button>
							)}
						</NavLink>
					) : (
						<button
							className={`${styles.navigation__button} ${styles.navigation__button__mobile}`}
							disabled
						>
							<Icon data={Gear} size={iconSize} />
							{ADMIN}
						</button>
					)}
				</div>
			</nav>
		</>
	);
};
